import { c as _c } from "react/compiler-runtime";
import { Button, HStack, VStack, Wrap, Field } from '@chakra-ui/react';
import { HelpModal } from '@src/components/sco/Requests/RequestBuilder/FormSections/HelpModal';
import { RequestBuilderFormProps } from '@src/components/sco/Requests/RequestBuilder/FormSections/index';
import { SelectableButtons } from '@src/components/sco/SelectableButtons';
import { UpsertGroupRequestInput } from '@src/graphql-types';
import React, { useEffect, useState } from 'react';
export const CommitmentCompensationSection: React.FC<RequestBuilderFormProps> = props => {
  const $ = _c(37);
  const groupRequest = props.groupRequest;
  const [showHelpModal, setShowHelpModal] = useState(false);
  let t0;
  if ($[0] !== groupRequest.compensationTypeKeys) {
    t0 = groupRequest.compensationTypeKeys || [];
    $[0] = groupRequest.compensationTypeKeys;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [compensationTypeKeys, setCompensationTypeKeys] = useState(t0);
  let t1;
  if ($[2] !== groupRequest.timeCommitmentTypeKeys) {
    t1 = groupRequest.timeCommitmentTypeKeys || [];
    $[2] = groupRequest.timeCommitmentTypeKeys;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [timeCommitmentTypeKeys, setTimeCommitmentTypeKeys] = useState(t1);
  let t2;
  if ($[4] !== groupRequest.userSearch.commitmentTypeKeys || $[5] !== groupRequest.userSearch.compensationTypeKeys) {
    t2 = () => {
      setCompensationTypeKeys(groupRequest.userSearch.compensationTypeKeys);
      setTimeCommitmentTypeKeys(groupRequest.userSearch.commitmentTypeKeys);
    };
    $[4] = groupRequest.userSearch.commitmentTypeKeys;
    $[5] = groupRequest.userSearch.compensationTypeKeys;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== groupRequest.userSearch.compensationTypeKeys) {
    t3 = [groupRequest.userSearch.compensationTypeKeys];
    $[7] = groupRequest.userSearch.compensationTypeKeys;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== compensationTypeKeys || $[10] !== props || $[11] !== timeCommitmentTypeKeys) {
    t4 = async t5 => {
      const next = t5 === undefined ? _temp : t5;
      if (!props.groupRequest.groupRequestId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertGroupRequest({
        variables: {
          input: {
            groupRequestId: props.groupRequest.groupRequestId,
            compensationTypeKeys,
            timeCommitmentTypeKeys
          } as UpsertGroupRequestInput
        }
      });
      if (next) {
        next();
      }
    };
    $[9] = compensationTypeKeys;
    $[10] = props;
    $[11] = timeCommitmentTypeKeys;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const performSave = t4;
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Field.Label>How will this person be compensated?</Field.Label>;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  let t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [{
      title: "Cash",
      key: "cash"
    }, {
      title: "Equity",
      key: "equity"
    }, {
      title: "Revenue Share",
      key: "revenue-share"
    }];
    t7 = {
      buttonProps: {
        flex: 1
      }
    };
    t8 = selections => setCompensationTypeKeys(selections.map(_temp2));
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[17] !== compensationTypeKeys) {
    t9 = <Field.Root>{t5}<Wrap><SelectableButtons defaultValue={compensationTypeKeys} options={t6} selectableButtonProps={t7} onChange={t8} /></Wrap></Field.Root>;
    $[17] = compensationTypeKeys;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Field.Label>What is the time-commitment?</Field.Label>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  let t12;
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [{
      title: "Full-Time",
      key: "full-time"
    }, {
      title: "Part-time",
      key: "part-time"
    }, {
      title: "One-Time",
      key: "one-time"
    }];
    t12 = {
      buttonProps: {
        flex: 1
      }
    };
    t13 = selections_0 => setTimeCommitmentTypeKeys(selections_0.map(_temp3));
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t11 = $[20];
    t12 = $[21];
    t13 = $[22];
  }
  let t14;
  if ($[23] !== timeCommitmentTypeKeys) {
    t14 = <Field.Root>{t10}<Wrap><SelectableButtons defaultValue={timeCommitmentTypeKeys} options={t11} selectableButtonProps={t12} onChange={t13} /></Wrap></Field.Root>;
    $[23] = timeCommitmentTypeKeys;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== performSave || $[26] !== props) {
    t15 = <HStack justify="flex-end" paddingY={2} width="full"><Button size="xs" variant="cta" onClick={async e => {
        await performSave(() => props.onNextSection ? props.onNextSection() : null);
      }}>{"Save & Continue"}</Button></HStack>;
    $[25] = performSave;
    $[26] = props;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t15 || $[30] !== t9) {
    t16 = <VStack align="stretch" gap={4} padding={4}>{t9}{t14}{t15}</VStack>;
    $[28] = t14;
    $[29] = t15;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== showHelpModal) {
    t17 = <HelpModal setShowHelpModal={setShowHelpModal} showHelpModal={showHelpModal} />;
    $[32] = showHelpModal;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t16 || $[35] !== t17) {
    t18 = <>{t16}{t17}</>;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
};
function _temp() {}
function _temp2(s) {
  return s.key;
}
function _temp3(s_0) {
  return s_0.key;
}